import React from 'react';
import { Timeline } from 'antd';
import SingleComment from './comments/comment';

export default function TimelineItem({ event, actions, loading }) {

    return (
    <>
      <Timeline.Item key={event.id}><SingleComment comment={event} actions={actions} /></Timeline.Item>
    </>
  );
}
